<div class="sub-menu-layout-container">
    <aside class="sub-menu-sidebar">
        <app-report-menu *ngIf="menuType === 'report'"></app-report-menu>
        <app-product-menu *ngIf="menuType === 'product'"></app-product-menu>
        <app-employee-menu *ngIf="menuType === 'employee'"></app-employee-menu>
        <app-promotion-menu *ngIf="menuType === 'promotion'"></app-promotion-menu>
        <app-user-menu *ngIf="menuType === 'user'"></app-user-menu>
        <app-system-menu *ngIf="menuType === 'system'"></app-system-menu>
        <app-util-menu *ngIf="menuType === 'utility'"></app-util-menu>
        <app-payroll-menu *ngIf="menuType === 'payroll'"></app-payroll-menu>
    </aside>
    <main class="content-area">
        <router-outlet></router-outlet>
    </main>
</div>